import { Selection } from './enums';
import * as moment from 'moment';

export function fetchData() {
  return fetch('/api/fetch_data');
}

export function login() {
  const token = window.gapi.auth2
    .getAuthInstance()
    .currentUser.get()
    .getAuthResponse().id_token;

  return fetch('/api/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    body: JSON.stringify({ token }),
  });
}

export function logout() {
  return fetch('/api/logout', {
    method: 'POST',
  });
}

export function submitPreferences(days: Selection[], bankDays: number) {
  return fetch('/api/submit_pool_days', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    body: JSON.stringify({
      bankDays,
      days,
    }),
  });
}

export function getEditors() {
  return fetch('/api/get_editors');
}

export function getEditorAssignments(
  email: string,
  startDate: string,
  endDate: string
) {
  return fetch(
    '/api/get_editor_assignment?email=' +
      encodeURIComponent(email) +
      '&startDate=' +
      encodeURIComponent(startDate) +
      '&endDate=' +
      encodeURIComponent(endDate)
  );
}

export function getAssignmentsInRange(startDate: string, endDate: string) {
  return fetch(
    '/api/get_assignments_for_dates?startDate=' +
      encodeURIComponent(startDate) +
      '&endDate=' +
      encodeURIComponent(endDate)
  );
}

//////////////////
// Admin API Calls
//////////////////

export function getAdmins() {
  return fetch('/api/get_admins');
}

export function addAdmin(email: string) {
  return fetch('/api/add_admin', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export function removeAdmin(email: string) {
  return fetch('/api/remove_admin', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export function getRoleRequirements() {
  return fetch('/api/get_role_requirements');
}

export function newScheduleRequest(data: ScheduleRequest) {
  return fetch('/api/new_schedule_request', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

/////////////////////////
// Distribute Assignments
/////////////////////////

export function distributeAssignments(
  fileData: File,
  assignmentDay: moment.Moment,
  notificationEmail: string
) {
  const formData = new FormData();
  formData.append('file', fileData);
  formData.append('assignmentDay', assignmentDay.format('YYYY-MM-DD'));
  formData.append('notificationEmail', notificationEmail);

  return fetch('/api/distribute_assignments', {
    method: 'POST',
    body: formData,
  });
}



// WEBPACK FOOTER //
// ./src/PoolAPI.ts